import React from 'react';
import axios from 'axios';
import config from '../config';
import './LicenseAlarmModal.css';

const LOCAL_LICENSE_CHECK_API = `${config.backendUrl}/api/local-license/check`;

export default function LicenseAlarmModal({
  onClose,
  onConfirm,
  checked = false,
  onCheckedChange,
}) {
  const closeModal = () => {
    if (typeof onClose === 'function') {
      onClose();
      return;
    }
    if (typeof onConfirm === 'function') {
      onConfirm();
    }
  };

  const handleCheckedChange = async (newChecked) => {
    try {
      await axios.post(LOCAL_LICENSE_CHECK_API, {
        is_license_check: newChecked ? 1 : 0,
      });

      onCheckedChange?.(newChecked);
    } catch (error) {
      console.error('Failed to save is_license_check.', error);
      // 저장 실패 시 체크 상태를 0으로 유지하고 모달을 닫는다.
      onCheckedChange?.(false);
      closeModal();
    }
  };

  const handleCloseAttempt = () => {
    if (!checked) {
      alert('확인하였습니다. 항목을 체크한 후 닫아주세요.');
      return;
    }

    closeModal();
  };

  return (
    <div className="license-alarm-modal-overlay">
      <div className="license-alarm-modal">
        <button
          type="button"
          className="license-alarm-close"
          onClick={handleCloseAttempt}
          aria-label="닫기"
        >
          x
        </button>

        <div className="license-alarm-title">
          <span className="license-alarm-warning-icon">⚠️</span>
          <span>라이센스가 곧 만료됩니다.</span>
        </div>

        <p className="license-alarm-description">
          라이센스가 만료되면 모니터링 사용이 중지되니 당사에 문의하여 라이센스 코드를 발급받으시기 바랍니다.
        </p>

        <div className="license-alarm-contact">
          <span className="license-alarm-phone-icon">☎</span>
          <span>062-674-9916 (월~금 9:00~18:00)</span>
        </div>

        <label className="license-alarm-confirm">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => handleCheckedChange(e.target.checked)}
          />
          <span>확인하였습니다.</span>
        </label>
      </div>
    </div>
  );
}